import { Button, Card, Modal, StatusIconProtoProps } from '@nike/eds';
import { useI18nContext } from '../../../context/language/use-i18n-context';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { ts } from './i18n';
import './qr-modal.css';
import { SendEmployeeEmail } from '../../../services/pass-service';
import { useUserContext } from '../../../context/user';
import { VisitorPass } from '../../../models/IVisitorPass';
import QRCode from 'react-qr-code';
import React from 'react';

export interface Props {
  onDismiss: () => void;
  isVisible: boolean;
  setSnackbar: Dispatch<
    SetStateAction<{
      showSnack: boolean;
      message: string;
      snackStatus: StatusIconProtoProps['status'];
    }>
  >;
  employeePass: VisitorPass | null;
}
export const QrModal: FC<Props> = ({ onDismiss, isVisible, setSnackbar, employeePass }) => {
  const { i18nString } = useI18nContext();
  const userInfo = useUserContext();
  const qrRef = React.createRef<HTMLDivElement>();
  const sendEmployeeEmail = () => {
    SendEmployeeEmail(userInfo?.passplayUser?.sponsorId)
      .then(() => {
        onDismiss();
        setSnackbar({
          message: i18nString(ts.SEND_QR_SUCCESS),
          showSnack: true,
          snackStatus: 'success',
        });
      })
      .catch(() => {
        setSnackbar({
          message: i18nString(ts.SEND_QR_FAIL),
          snackStatus: 'error',
          showSnack: true,
        });
      });
  };
  const downloadQrCode = () => {
    const svg = qrRef.current?.firstChild;
    const svgData = new XMLSerializer().serializeToString(svg as HTMLElement);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.download = 'QRCode';
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  const header = (
    <h1
      data-testid="qr-modal-header"
      className={`eds-flex eds-flex--justify-content-center modal_header`}
    >
      {i18nString(ts.EMPLOYEE_MY_PASS)}
    </h1>
  );
  const footer = (
    <div className={`eds-flex eds-flex--justify-content-center`}>
      <Button
        size="small"
        variant="primary"
        onClick={sendEmployeeEmail}
        className={`btn_color`}
        data-testid="send-pass"
      >
        {i18nString(ts.EMAIL_MY_PASS)}
      </Button>
    </div>
  );
  return (
    <div>
      <Modal
        hideFade
        headerSlot={header}
        footerSlot={footer}
        isOpen={isVisible}
        onDismiss={onDismiss}
        title="Download QR Code"
      >
        <Card className={`eds-spacing--p-32 qr__modal`}>
          <div className="panel__section">{i18nString(ts.QR_CODE_COPY)}</div>
          <div
            ref={qrRef}
            className="eds-flex eds-flex--justify-content-center panel__section eds-spacing--pt-16"
          >
            <>
              <QRCode
                data-testid="qr-code"
                id="qr-code"
                value={employeePass?.alternateId || ''}
                size={100}
                onClick={downloadQrCode}
                className="qr_pointer"
              />
            </>
          </div>
        </Card>
      </Modal>
    </div>
  );
};
